export default __webpack_public_path__ + "static/media/ParentTask.3ff1594e.svg";